import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorIllustration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 73,
	height: 68,
	viewBox: "0 0 73 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.0136061 29.9102C0.0045509 29.8559 0 29.8009 0 29.7458L0 26.6571C0 26.1048 0.447715 25.6571 1 25.6571H9.42857C9.98085 25.6571 10.4286 26.1049 10.4286 26.6571V28.8286C10.4286 29.3808 10.8763 29.8286 11.4286 29.8286H44.8857C45.438 29.8286 45.8857 30.2763 45.8857 30.8286V66.3714C45.8857 66.9237 45.438 67.3714 44.8857 67.3714H7.10427C6.61543 67.3714 6.19824 67.018 6.11788 66.5358L0.0136061 29.9102Z",
			fill: "var(--file-back)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 29,
			width: 45.8857,
			height: 37.5429,
			rx: 1,
			fill: "var(--file-front)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M39.543 0.628571C38.4384 0.628571 37.543 1.524 37.543 2.62857V17.4C37.543 18.5046 38.4384 19.4 39.543 19.4H42.7573V25.6571L49.0144 19.4H71.0001C72.1047 19.4 73.0001 18.5046 73.0001 17.4V2.62857C73.0001 1.524 72.1047 0.628571 71.0001 0.628571H39.543Z",
			fill: "var(--bubble)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M53.391 4.87931C54.0972 3.7069 55.9037 3.7069 56.609 4.87931L61.7601 13.431C62.4525 14.581 61.5635 16 60.152 16H49.8489C48.4365 16 47.5475 14.581 48.2399 13.431L53.391 4.87931ZM55.9231 13.4147C55.9231 13.6433 55.8259 13.8626 55.6527 14.0242C55.4796 14.1859 55.2448 14.2767 55 14.2767C54.7552 14.2767 54.5204 14.1859 54.3472 14.0242C54.1741 13.8626 54.0769 13.6433 54.0769 13.4147C54.0769 13.186 54.1741 12.9668 54.3472 12.8051C54.5204 12.6434 54.7552 12.5526 55 12.5526C55.2448 12.5526 55.4796 12.6434 55.6527 12.8051C55.8259 12.9668 55.9231 13.186 55.9231 13.4147ZM55 6.5181C54.7552 6.5181 54.5204 6.60893 54.3472 6.7706C54.1741 6.93227 54.0769 7.15154 54.0769 7.38017V9.96638C54.0769 10.195 54.1741 10.4143 54.3472 10.576C54.5204 10.7376 54.7552 10.8284 55 10.8284C55.2448 10.8284 55.4796 10.7376 55.6527 10.576C55.8259 10.4143 55.9231 10.195 55.9231 9.96638V7.38017C55.9231 7.15154 55.8259 6.93227 55.6527 6.7706C55.4796 6.60893 55.2448 6.5181 55 6.5181Z",
			fill: "var(--warning)"
		})
	]
});
export default SvgErrorIllustration;
